export enum LicencedProduct {
  CherryPay = "CherryPay",
  CherryPlay = "CherryPlay",
  CherryChat = "CherryChat",
  CherryCheck = "CherryCheck",
  CherryPass = "CherryPass",
  Worldpay = "Worldpay",
}

export const LicencedProductList = () =>
  Object.entries(LicencedProduct).map(([label, value]) => {
    return value;
  });
